var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-if=\"listing.isActive() &amp;&amp; listing.isJustListed()\" class=\"label label-success\"><div class=\"card-label-heading\">Just listed</div></div><div ng-if=\"listing.isActive() &amp;&amp; !listing.isJustListed() &amp;&amp; showActive\" class=\"label label-success\"><div class=\"card-label-heading\">Active</div></div><div ng-if=\"listing.isPending()\" class=\"label label-info-dark\"><div class=\"card-label-heading\">Pending</div></div><div ng-if=\"listing.isSold()\" class=\"label label-info-dark\"><div class=\"card-label-heading\">Sold</div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-listing-status.jade
 ** module id = 3497
 ** module chunks = 3
 **/